import { Link } from 'react-router-dom';

function ResetPasswordHeader() {
    return (
        <header className="flex items-center justify-between border-b border-solid border-white/10 px-6 py-4 md:px-20 lg:px-40">
            <Link to="/">
                <div className="flex items-center gap-3">
                    <div className="size-8 bg-primary rounded flex items-center justify-center">
                        <span className="material-symbols-outlined text-white text-xl">speed</span>
                    </div>
                    <h1 className="text-xl font-bold tracking-tight text-white uppercase italic"><span className="text-primary">Live</span>Telemetry</h1>
                </div>
            </Link>
        </header>
    );
}

export default ResetPasswordHeader;